import { render, staticRenderFns } from "./ImageAndVideoDialog.vue?vue&type=template&id=4a2ccb90&scoped=true&"
import script from "./ImageAndVideoDialog.vue?vue&type=script&lang=js&"
export * from "./ImageAndVideoDialog.vue?vue&type=script&lang=js&"
import style0 from "./ImageAndVideoDialog.vue?vue&type=style&index=0&id=4a2ccb90&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a2ccb90",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("G:\\jenkinsworkspace\\Aigo.B2CAdmin.Publish\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4a2ccb90')) {
      api.createRecord('4a2ccb90', component.options)
    } else {
      api.reload('4a2ccb90', component.options)
    }
    module.hot.accept("./ImageAndVideoDialog.vue?vue&type=template&id=4a2ccb90&scoped=true&", function () {
      api.rerender('4a2ccb90', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/comment/components/ImageAndVideoDialog.vue"
export default component.exports